import React, { Component } from 'react'
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';

import { grid_spacing, styles } from '../../CSS/Styles';

import scale from '../../../pic/scale.PNG';
import grey from '../../../pic/grey.PNG';
import dot from '../../../pic/dot.PNG';

import PropTypes from 'prop-types';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Slider from '@material-ui/core/Slider';
import Tooltip from '@material-ui/core/Tooltip';


const useStyles = makeStyles(theme => ({
  root: {
    width: 300 + 24 * 2,
    padding: 24,
  },
  margin: {
    height: theme.spacing(3),
  },
}));

function ValueLabelComponent(props) {
  const { children, open, value } = props;

  const popperRef = React.useRef(null);
  React.useEffect(() => {
    if (popperRef.current) {
      popperRef.current.update();
    }
  });

  return (
    <Tooltip
      PopperProps={{
        popperRef,
      }}
      open={open}
      enterTouchDelay={0}
      placement="top"
      title={value}
    >
      {children}
    </Tooltip>
  );
}

ValueLabelComponent.propTypes = {
  children: PropTypes.element.isRequired,
  open: PropTypes.bool.isRequired,
  value: PropTypes.number.isRequired,
};

const iOSBoxShadow =
  '0 3px 1px rgba(0,0,0,0.1),0 4px 8px rgba(0,0,0,0.13),0 0 0 1px rgba(0,0,0,0.02)';

const marks = [
  {
    value: 0,
  },
  {
    value: 20,
  },
  {
    value: 37,
  },
  {
    value: 100,
  },
];

const IOSSlider = withStyles({
  root: {
    color: 'transparent',//'#9e9e9e','transparent',
    height: 19,
    // padding: '15px 0',
  },
  thumb: {
    height: 36,
    width: 36,
    backgroundColor: '#212121',
    boxShadow: iOSBoxShadow,
    marginTop: -3,
    marginLeft: -18,
    opacity: 0,
    '&:focus,&:hover,&$active': {
      boxShadow: '0 3px 1px rgba(0,0,0,0.1),0 4px 8px rgba(0,0,0,0.3),0 0 0 1px rgba(0,0,0,0.02)',
      // Reset on touch devices, it doesn't add specificity
      '@media (hover: none)': {
        boxShadow: iOSBoxShadow,
      },
    },
    ////////////////////////////////////////////////////////////backgroundImage: '`url(${ dot })`'
  },
  active: {},
  valueLabel: {
    opacity: 0,
    left: 'calc(-50% + 11px)',
    top: -22,
    '& *': {
      background: 'transparent',
      color: '#000',
    },
  },
  track: {
    height: 22,
    opacity: 1, //0 then thumb left invisible
    backgroundColor: '#9e9e9e',
    // backgroundImage: '`url(${ dot })`'

  },
  rail: {
    height: 30,
    opacity: 0,
    backgroundColor: '#bfbfbf',
    // backgroundImage: '`url(${ dot })`'
  },
  //   mark: {
  //     backgroundColor: '#bfbfbf',
  //     height: 8,
  //     width: 1,
  //     marginTop: -3,
  //   },
  //   markActive: {
  //     backgroundColor: 'currentColor',
  //   },
})(Slider);


const IOSSlider2 = withStyles({
  root: {
    color: 'transparent',//'#9e9e9e','transparent',
    height: 19,
    // padding: '15px 0',
  },
  thumb: {
    height: 36,
    width: 36,
    backgroundColor: '#212121',
    boxShadow: iOSBoxShadow,
    marginTop: -3,
    marginLeft: -18,
    '&:focus,&:hover,&$active': {
      boxShadow: '0 3px 1px rgba(0,0,0,0.1),0 4px 8px rgba(0,0,0,0.3),0 0 0 1px rgba(0,0,0,0.02)',
      // Reset on touch devices, it doesn't add specificity
      '@media (hover: none)': {
        boxShadow: iOSBoxShadow,
      },
    },
    ////////////////////////////////////////////////////////////backgroundImage: '`url(${ dot })`'
  },
  active: {},
  valueLabel: {
    left: 'calc(-50% + 11px)',
    top: -22,
    '& *': {
      background: 'transparent',
      color: '#000',
    },
  },
  track: {
    height: 22,
    opacity: 1, //0 then thumb left invisible
    backgroundColor: '#9e9e9e',
    // backgroundImage: '`url(${ dot })`'

  },
  rail: {
    height: 30,
    opacity: 0,
    backgroundColor: '#bfbfbf',
    // backgroundImage: '`url(${ dot })`'
  },
  //   mark: {
  //     backgroundColor: '#bfbfbf',
  //     height: 8,
  //     width: 1,
  //     marginTop: -3,
  //   },
  //   markActive: {
  //     backgroundColor: 'currentColor',
  //   },
})(Slider);


// export default function CustomizedSlider() {
//   const classes = useStyles();

//   return (
//     <Paper className={classes.root}>
//       <Typography gutterBottom>iOS</Typography>
//       <IOSSlider aria-label="ios slider" defaultValue={60} marks={marks} valueLabelDisplay="on" />
//       <div className={classes.margin} />
//     </Paper>
//   );
// }


class VenderRiskScore extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: 0
    }
  }

  handleChange = (event, value) => {
    this.setState({ value });
  };

  getInitialState() {
  }

  componentDidMount() {
  }

  componentWillMount() {

  }
  render() {
    const { classes } = this.props;
    const risk = 43;
    const scale_position = risk - 50;
    return (
      // <div style = {{height: 60, width: 1400}} style = {{backgroundImage: `url(${ scale })` }}>
      //     <img src={scale} style={{ width: 1200, height: 16}} />
      //     <img src={grey} style={{ width: 60, height: 16, left: -60, position: 'relative', zIndex: 2}} />
      //     <div style={{left: -630, bottom: 47, position: 'relative', zIndex: 3}}>
      //         <Typography variant="body1">68%</Typography>
      //         <img src={dot} style={{ width: 25, height: 28}} />
      //     </div>
      // </div>
      <div  >
        <div style={{ backgroundImage: `url(${scale})`, backgroundSize: "100% 48%", backgroundPosition: 'center', backgroundRepeat: 'no-repeat' }}>
          <IOSSlider value={[risk, 100]} valueLabelDisplay="on" />
        </div>
        <div style={{ position: 'relative', zIndex: 3, top: -61, left: scale_position + '%' }}>
          <Typography variant="body1">{risk}%</Typography>
          <img src={dot} style={{ width: 32, height: 36 }} />
        </div>
        {/* <Typography variant="body1" style = {{top: -61, position: 'relative', zIndex: 3, left: 140}}>68%</Typography>
                <img src={dot} style={{ width: 32, height: 36, top: -61, position: 'relative', zIndex: 3, left: 140}} /> */}
        {/* <IOSSlider2 value={[60]} valueLabelDisplay="on" style = {{top: -48}}/>  */}
      </div>



    )
  }
}

export default withStyles(styles)(VenderRiskScore);


// WEBPACK FOOTER //
// ./src/components/Entities/vendor/VenderRiskScore.js